module.exports = __webpack_public_path__ + "92896df1.svg";